import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

const LeftAlignedGrid = styled(Grid)`
  && {
    text-align:left;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const RightAlignedGrid = styled(Grid)`
  && {
    text-align:right;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const DateText = styled.div`
  font-size:17px;
`;
const THREE = 3;
const TWO = 2;
const SpreadMaintenanceResult = ({ result, prepaymentResult, prepaymentParameters }) => (
  <>
    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
    {prepaymentParameters?.shouldUsePV && <LeftAlignedGrid item xs={6}>Discount Rate</LeftAlignedGrid>}
    {prepaymentParameters?.shouldUsePV && <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.discountRate, THREE, "-")}</RightAlignedGrid>}
    {prepaymentParameters?.shouldUsePV && <LeftAlignedGrid item xs={6}>Discount Rate Lookback</LeftAlignedGrid>}
    {prepaymentParameters?.shouldUsePV && <RightAlignedGrid item xs={6}>{prepaymentResult.lookbackDays}{" "}business days</RightAlignedGrid>}
    <LeftAlignedGrid item xs={6}>Minimum Penalty</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.minimumPrepaymentPenalty, TWO, "-")}</RightAlignedGrid>
  </>
);

export default SpreadMaintenanceResult;
